import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GraphComponent } from './graph.component';

@NgModule({
  declarations: [GraphComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [GraphComponent],
})
export class GraphModule {}
